import { useQuery } from '@tanstack/react-query'
import { usersAPI } from '../services/api'

export const useUserDetails = (userId, options = {}) => {
  return useQuery({
    queryKey: ['admin', 'user-details', userId],
    queryFn: async () => {
      if (!userId) {
        throw new Error('User ID is required')
      }
      
      const response = await usersAPI.getUserDetails(userId)
      return response.data.data
    },
    enabled: !!userId && options.enabled !== false,
    staleTime: 30000, // 30 seconds
    refetchOnWindowFocus: false,
    ...options,
  })
}

export const useUserNotes = (userId, { page = 1, limit = 10 } = {}) => {
  return useQuery({
    queryKey: ['admin', 'user-notes', userId, { page, limit }],
    queryFn: async () => {
      if (!userId) {
        throw new Error('User ID is required')
      }
      
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
      })
      
      const response = await usersAPI.getUserNotes(userId, Object.fromEntries(params))
      return response.data.data
    },
    enabled: !!userId,
    staleTime: 60000, // 1 minute
    refetchOnWindowFocus: false,
  })
}